import { Injectable } from '@angular/core';
import { SurveyService } from '../../../../../core/services/survey/survey.service';
import { FormAuthService } from '../../../../../core/services/auth/form-auth.service';
import { M1Member, RequestParameters } from '@tangilla/tg-ng-models';
import { NrdsAssociationsApiService, NrdsMembersApiService } from '@tangilla/tg-ng-core';
import { MembersUtilsService } from '../../../../../core/services/utils/members.utils.service';
import { ItemValue } from 'survey-core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class M1SearchRecordsService {
  questionJson: any;

  constructor(private surveyService: SurveyService,
              private membersUtilsService: MembersUtilsService) {
  }

  checkMemberStatus(m1Member: M1Member, primaryLocalAssociationName?: string) {
    if (m1Member.status === 'S') {
      this.showStatusError('Suspended', primaryLocalAssociationName);
    } else if (m1Member.status === 'T') {
      this.showStatusError('Terminated', primaryLocalAssociationName);
    }
  }

  showStatusError(errorStatusText: string, primaryLocalAssociationName?: string) {
    const primaryLocalAssociationText = primaryLocalAssociationName ? ` You will need to make contact with ${primaryLocalAssociationName} to resolve.` : '';

    this.surveyService.surveyModel.setVariable('nrds_request_error', `Your NAR membership was ${errorStatusText}.${primaryLocalAssociationText}`);
    // $('#NRDSsearchError').html(this.surveyService.surveyModel.getVariable('nrds_request_error')).show();
  }

  mapQuestionJsonChoices(m1Member: M1Member) {
    const nrdsQuestion = this.questionJson
      .questions?.find((question: any) => question.name === 'NRDS');

    if (nrdsQuestion) {
      const memberDescription = this.getMemberDescription(m1Member);
      const surveyItem = new ItemValue(m1Member.member_nrds_id, memberDescription);
      nrdsQuestion.choices.push(surveyItem);
      nrdsQuestion.visible = true;
    }
  }

  private getMemberDescription(m1Member: any) {
    const middleName = m1Member.middle_name ? ` ${m1Member.middle_name}` : '';
    const memberFullName = `${m1Member.first_name}${middleName} ${m1Member.last_name}`;

    const officeDescription = this.getOfficeDescription(m1Member);

    return `${memberFullName}${officeDescription} #${m1Member.member_nrds_id} ${this.membersUtilsService.getMemberStatusText(m1Member.status)}`;
  }

  private getOfficeDescription(m1Member: any) {
    const officeCity = m1Member.office_city ? ` - ${m1Member.office_city}` : '';
    const officeState = m1Member.office_state ? `, ${m1Member.office_state}` : '';
    return m1Member.office_name ?
      ` (${m1Member.office_name}${officeCity}${officeState})` :
      '';
  }
}
